<div class="dtf-accountdetails">
 <style>
    /* Dialog and container layout */
    .dtf-accountdetails {
      padding: 24px;
      font-family: Arial, sans-serif;
      max-width: 500px;
      margin: 0 auto;
    }

    .reading-summary-header {
      text-align: left;
      margin-bottom: 16px;
    }

    .reading-summary-header h3 {
      font-size: 16px;
      font-weight: bold;
    }

    .reading-summary-header p {
      font-size: 14px;
      margin: 4px 0;
    }

    /* Table styling */
    .reading-table {
      width: 100%;
      border-collapse: collapse;
      font-size: 14px;
    }

    .reading-table th,
    .reading-table td {
      padding: 10px 8px;
      text-align: left;
    }

    .reading-table th {
      font-weight: bold;
      border-bottom: 1px solid #ccc;
    }

    .reading-table td {
      border-bottom: 1px solid #eee;
    }

    /* Footer and disclaimer */
    #mbfs-footer {
      margin-top: 20px;
      padding-top: 10px;
      border-top: 1px solid #ddd;
    }

    #mbfs-footer .paragraph1 {
      font-size: 12px;
      color: #555;
      line-height: 1.4;
      margin: 0;
    }


  </style>


  <mat-dialog-content>

    <!-- Spinner for loading -->
    @if (!this.tableLoaded) {
      <div class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
        <div class="demo-container">
          <span>Retrieving History</span>
          <div class="progress-bar">
            <div class="progress-bar-value"></div>
          </div>
        </div>
        <br />
      </div>
    }

    <!-- Table Content -->
    @if (this.tableLoaded && statusMessage === 'SUCCESS') {
      <div class="reading-summary-header">
        <b>VIN Number: {{this.assetSelected}}</b><br/>
        <b>Adjusted Residual Value: ${{formatNumber(this.residualTotal)}}</b>
      </div>

      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 reading-table">

        @for(column of initColumns; track column) {
          <ng-container matColumnDef="{{column.name}}">
            <th mat-header-cell *matHeaderCellDef> {{column.display}} </th>
            <td mat-cell *matCellDef="let element" style="justify-content: center;">
              @if(column.dispFormat == '') {
                {{element[column.name] || 0}}
              }
              @if(column.dispFormat == 'date') {
                {{ formatDate(element?.[column?.name]) }}
              }
              @if(column.dispFormat == 'numbers') {
               {{ formatNumber(element[column.name]) }} miles
              }
            </td>
          </ng-container>
        }

        <ng-container matColumnDef="dynamicAddendumRes">
          <td class="example-element-detailed-row" mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
            <!-- optional content -->
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
    }

    <!-- Error or No Data -->
    @if (this.tableLoaded && statusMessage !== 'SUCCESS') {
      <p>No data found or an error occurred.</p>
      <button mat-button (click)="closeDialog('invalid')">Close</button>
    }

  </mat-dialog-content>

  <mat-dialog-actions>
<footer id="mbfs-footer">
<div role="contentinfo">
  <div class="mbfs-copyright">
   <p class="paragraph2">
         This data is for informational purposes related to mileage usage only and does not reflect all fees and charges that may appear on your monthly invoice.
    </p>
  </div>
</div>
</footer>

    <button mat-button (click)="closeDialog('invalid')">Close</button>

  </mat-dialog-actions>
</div>